/*
 * @Author: cgh
 * @Date: 2022-08-02 15:57:03
 * @LastEditors: cgh
 * @LastEditTime: 2022-08-02 15:58:23
 * @Description: 人员签到信息路由
 */

const ryqdxxRoutes = {
  path: 'ryqdxx',
  name: 'ryqdxx',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'ryqdxxManage',
      component: () => import(/* webpackChunkName: "ryqdxxManageList" */ '@/features/xfaqpg/ryqdxx/list.vue'),
      meta: {
        navtabTitle: '人员签到信息',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    }
  ]
};

export default ryqdxxRoutes;
